import { change } from 'redux-form';

export const changeFieldValue = (formName, fieldName, newValue) => {
  return async (dispatch, getState) => {
    dispatch(change(formName, fieldName, newValue));
  };
};
